import(/* webpackMode: "eager" */ "/vercel/path0/src/app/workout/page.tsx");
